import { Abacus } from "core/Abacus.Core";
import { TimeZoneFormat } from "core/classes/date.timezone.format.class.js";
import { TableFix } from "core/classes/tablefix.class.js";
import "lazysizes";
import { TableFullscreen } from "core/classes/table.fullscreen.class.js";
import { ReCaptchaElement } from "core/classes/recaptcha.class";
import { AJAXSaveBookmark } from "core/classes/savebookmark/ajax.savebookmark.class";
import { AJAXLoadContent } from "core/classes/loadmoreitems/ajax.loadcontent.class";
import { NativeContent } from "core/classes/native-content-reflow-ajax.class";
import { LoadMoreItemsAJAX } from "core/classes/loadmoreitems/ajax.loadmoreitems.class";
import { FacebookShare } from "core/classes/socialshare/facebook.share.class";
import { TwitterShare } from "core/classes/socialshare/twitter.share.class";
import { LinkedinShare } from "core/classes/socialshare/linkedin.share.class";
import { WhatsappShare } from "core/classes/socialshare/whatsapp.share.class";
import { CommentEntry } from "core/classes/comments/comments.class";
import "core/classes/popups/popup.class";
import "core/classes/attachments/attachments.class";
import { ImageFilename } from "core/classes/account/account.image.class";
import { AccountDropdown } from "core/classes/account/account.menu.class";
import { AccountUpdate } from "core/classes/account/account.update.class";
import { LoadMoreItems } from "core/classes/loadmoreitems/loadmoreitems.class";
import { CommentVote } from "core/classes/comments/comments.vote.class";
import { CommentSort } from "core/classes/comments/comments.sort.class";
import { ToggleMenu } from "core/classes/menu/toggle.class";
import { MultiToggleMenu } from "core/classes/menu/toggle.class";
import { MobileMenu } from "core/classes/menu/mobile.menu.class";
import { StoryGallery } from "core/classes/galleries/gallery.story.class";
import "core/classes/scrollers/scroller.class";
import "core/classes/spin2/pic.carousel.class";
import "core/classes/scroll/sticky.element";
import { CookiePolicy } from "core/classes/cookiepolicy.class";
import "core/classes/scrollto.class";
import "core/classes/jumpto.class";
import "core/classes/sticky.class";
import "core/classes/reflow.content.class";
import "core/classes/menu/menu.class";
import { FilteredSearch } from "core/classes/mast.filter.search.class";
import { EmailRssPreview } from "libraries/EmailRssPreview/email.rss.preview";
import { DatePicker } from "core/classes/searchresults/search.date.picker";
import { SearchAJAX } from "core/classes/searchresults/search.ajax";
import { ShowHideHelp } from "core/classes/searchresults/search.help";
import { Detector } from "core/classes/popups/block.class";
import { NewsletterSignup } from "core/classes/newsletter/newsletter-signup.class";
import { ImageZoom } from "core/classes/zoom/image.zoom.class";
import "core/classes/widgets.class";
import "core/classes/spin2/spin.video.class";
import "core/classes/spin2/spin.video.preview.class";
import "jquery/plugins/sticky.column.js";
import "picturefill";
import "core/classes/hottopics.class";
import "core/classes/story/rating.class";
import "core/classes/explorer/explorer.class";
import "core/classes/taxonomy/taxonomy.class";
import { Autocomplete } from "core/classes/autocomplete.class";
import "core/classes/explorer/explorer.class";
import "core/classes/widgets/resource-search.class";
import "core/classes/widgets/widget-search-picker.class";
import "core/classes/spin-hero";
import "core/classes/ipmessaging.class";
import "core/classes/contentclose/content.close.block.class";
import { CurriculumExplorer } from "core/classes/explorer/explorer.class";
import { LongformGalleriesStyleOne } from "core/classes/longform-galleries";
// import { ScrollbarFix } from "core/classes/ScrollbarFix";

window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.init = false;

$(function() {
  // if (!Abacus.PreventDefault.ScrollbarFix) {
  //   new ScrollbarFix();
  // }
  $(".filter-search").each(function() {
    new FilteredSearch(this);
  });

  $(".backToSearchresults a").on("click", function(evt) {
    // if local storage, append qs to back
    // else use browser back
    if (localStorage.getItem("abacus:searchfilter:applied")) {
      $(this).prop("href", localStorage.getItem("abacus:searchfilter:applied"));
    } else {
      evt.preventDefault();
      history.back();
    }
  });

  if (!Abacus.PreventDefault.SearchAJAX) {
    if(!$(".search-update-container").length) {
      $(".searchDetails form").on("change", "[data-submit-form-on-change]", function(e) {
        window.location.href = $(this).parents("form").attr("action") + "&val=" + this.value;
      });
    }else{
      $(".search-update-container").each(function() {
        new SearchAJAX(this);
      });
    }
  }

  if (!Abacus.PreventDefault.TimeZoneFormat) {
    $(".date").each(function(i, el) {
      new TimeZoneFormat(this);
    });
  }

  if (!Abacus.PreventDefault.AJAXLoadContent) {
    $("[data-ajax-load-content]").each(function() {
      new AJAXLoadContent(this);
    });
  }

  if (!Abacus.PreventDefault.TableFix) {
    $(".storytext TABLE").each(function() {
      new TableFix(this);
    });
  }
  if (!Abacus.PreventDefault.TableFullscreen) {
    if (document.body.id == "story" || document.body.id == "story_custom") {
      $(".storytext div.table-full").each(function() {
        new TableFullscreen(this);
      });
    }
  }
  if (!Abacus.PreventDefault.LoadMoreItems) {
    $("[data-load-more-ajax]").each(function() {
      new LoadMoreItemsAJAX(this);
    });
  }
  if (!Abacus.PreventDefault.FacebookShare) {
    new FacebookShare(document.body);
  }
  if (!Abacus.PreventDefault.TwitterShare) {
    new TwitterShare(document.body);
  }
  if (!Abacus.PreventDefault.LinkedinShare) {
    new LinkedinShare(document.body);
  }
  if (!Abacus.PreventDefault.WhatsappShare) {
    new WhatsappShare(document.body);
  }
  if (!Abacus.PreventDefault.CommentEntry) {
    $("#StoryComment").each(function() {
      new CommentEntry(this);
    });
  }
  if (
    document.querySelector('meta[name="showwallpaper"]') &&
    document.querySelector('meta[name="showwallpaper"]').content == "false"
  ) {
    if (!Abacus.PreventDefault.StoryGallery) {
      $(".storyGallery").each(function() {
        new StoryGallery(this);
      });
    }
  }
  if (!Abacus.PreventDefault.ImageFilename) {
    new ImageFilename();
  }
  if (!Abacus.PreventDefault.AccountMenu) {
    $("#colmain .myAccountNavigation").each(function() {
      new AccountDropdown(this);
    });
  }
  if (!Abacus.PreventDefault.AccountUpdate) {
    $(".ajax-update").each(function() {
      new AccountUpdate(this);
    });
  }
  if (!Abacus.PreventDefault.LoadMoreItems) {
    $("[data-load-more]").each(function() {
      new LoadMoreItems(this);
    });
  }
  if (!Abacus.PreventDefault.CommentVote) {
    $("#comments")
      .find("li:not('.editor_comment')")
      .each(function() {
        new CommentVote(this);
      });
  }

  if (!Abacus.PreventDefault.ToggleMenu) {
    $("[data-toggle-menu]").each(function() {
      new ToggleMenu(this);
    });
  }
  if (!Abacus.PreventDefault.MultiToggleMenu) {
    $("[data-multi-toggle-menu]").each(function() {
      new MultiToggleMenu(this);
    });
  }
  if (!Abacus.PreventDefault.MobileMenu) {
    $(".mobileMenu").each(function() {
      new MobileMenu(this);
    });
  }
  if (!Abacus.PreventDefault.CookiePolicy) {
    $("#cookiePolicy").each(function() {
      new CookiePolicy(this);
    });
  }
  // if (!Abacus.PreventDefault.CommentSort) {
  //   $("[ajax-submit-on-change]").each(function() {
  //     new CommentSort(this);
  //   });
  // }
  if (!Abacus.PreventDefault.EmailRssPreview) {
    $("[data-emailRssPreview]").each(function() {
      new EmailRssPreview();
    });
  }
  if (!Abacus.PreventDefault.DatePicker) {
    $(".date-picker:not([data-rule-searchdateformat])").each(function() {
      new DatePicker(this, {
        field: this,
        format: "DD-MM-YYYY",
        yearRange: [2000, 2040],
        maxDate: new Date(),
        firstDay: 1
      });
    });
  }

  if (!Abacus.PreventDefault.Detector) {
    new Detector(this);
  }

  if (!Abacus.PreventDefault.ImageZoom) {
    $(".image_size_full.zoom").each(function() {
      new ImageZoom(this);
    });
    $(".image_size_med.zoom").each(function() {
      new ImageZoom(this);
    });
  }
  if (!Abacus.PreventDefault.Directories) {
    // ajax widget
    $(window).on("abacus:customwidget:complete", function(evt, context) {
      if (context.find(".widget-directories-search").length) {
        adjustscrollabletabs(context);
        $(window).on("resize", function(event) {
          adjustscrollabletabs(context);
        });
        $(
          ".widget-directories-search .tabs,.company-header__company-tabs",
          context
        ).each(function() {
          var $tab = $(this);
          $tab.find(".tab-content").hide();
          $($tab.find(".nav .selected a", $tab).attr("href"), $tab).show();

          $tab.find(".nav a").off();
          $tab.find(".nav a").on("click", function(event) {
            event.preventDefault();
            var $a = $(this);
            $a.parents(".tabs")
              .find(".tab-content")
              .hide();
            $a.parents(".tabs")
              .find(
                '.tab-content[id="' + $a.attr("href").replace(/^#/, "") + '"]'
              )
              .show();
            $a.parent()
              .addClass("selected")
              .siblings()
              .removeClass("selected");
            return false;
          });

          // find all <a> with href starting with a '#' in tab-content
          $tab.find('.tab-content a[href^="#"]').off();
          $tab.find('.tab-content a[href^="#"]').on("click", function(e) {
            if ($(this).attr("href") != "#") {
              e.preventDefault();
              $tab
                .find('.nav a[href="' + $(this).attr("href") + '"]')
                .trigger("click");
              return false;
            }
          });
        });
      }
      if (context.find(".widget-asset-search-form").length) {
        $(
          ".widget-asset-search-form [data-cascade-enable-onchange]",
          context
        ).on("change", function(event) {
          var $this = $(this);
          $.ajax({
            url:
              $this.data("url") +
              "&parent=" +
              ($this.val().indexOf("|") == -1
                ? $this.val()
                : $this.val().split("|")[1]),
            context: $this,
            beforeSend: function(xhr) {
              $this.parents(".spinLayout").addClass("loading");
              var child = $this.data("cascade-enable-onchange");
              var childSelect = $this
                .parents(".widget-asset-search-form")
                .find('select[id="' + child + '"]');
              var childDefaultOption = $("<div></div>")
                .append($("option:first-child", childSelect).clone())
                .html();
              childSelect.empty().append(childDefaultOption);
            },
            error: function(jqXHR, textStatus, errorThrown) {
              console.log(
                "Error executing AJAX request for .widget-asset-search-form widget control " +
                  $this.attr("data-cascade-enable-onchange") +
                  "/." +
                  $this.attr("class") +
                  ": " +
                  textStatus,
                errorThrown
              );
              $this.parents(".spinLayout").removeClass("loading");
              var child = $this.data("cascade-enable-onchange");
              var childSelect = $this
                .parents(".widget-asset-search-form")
                .find('select[id="' + child + '"]');
              var childDefaultOption = $("<div></div>")
                .append($("option:first-child", childSelect).clone())
                .html();
              childSelect.empty().append(childDefaultOption);
            },
            success: function(data, textStatus, jqXHR) {
              $this.parents(".spinLayout").removeClass("loading");
              var child = $this.data("cascade-enable-onchange");
              var childSelect = $this
                .parents(".widget-asset-search-form")
                .find('select[id="' + child + '"]');
              var childDefaultOption = $("<div></div>")
                .append($("option:first-child", childSelect).clone())
                .html();
              childSelect.empty().append(childDefaultOption);
              if ($(data).data("count") && $(data).is("options")) {
                childSelect.append($(data).html());
              }
              if ($this.val()) {
                childSelect.prop("disabled", false);
              } else {
                childSelect
                  .prop("disabled", "disabled")
                  .find('option[value=""]')
                  .prop("selected", "selected");
              }
            }
          });
        });
        $(".widget-asset-search-form", context).off("click");
        $(".widget-asset-search-form", context).on("click", ".btn", function(
          event
        ) {
          event.preventDefault();
          var $this = $(this);
          var $form = $this.parents("form");
          var $formElements = $("input,select,textarea", $form);
          var formURLParameters = [];
          $formElements.each(function(index, element) {
            var $element = $(element),
              elemValue = $element.val(),
              childId = $element.attr("data-cascade-enable-onchange"),
              add = true;
            // check which parameters should be removed
            // if parent selected, but child not - select parent
            // if parent selected and child selected, select just child
            if (childId) {
              var childElement = $element
                .parents(".widget-asset-search-form")
                .find('select[id="' + childId + '"]');
              if (childElement.val()) {
                add = false;
                formURLParameters.push(
                  childElement.attr("name") + "=" + childElement.val()
                );
              }
            }
            if (elemValue && !element.disabled && add) {
              var valueToAdd = element.name + "=" + elemValue;
              if (formURLParameters.indexOf(valueToAdd) == -1) {
                formURLParameters.push(valueToAdd);
              }
            }
          });
          if (formURLParameters.length) {
            var formActionURL = $form.attr("action");
            window.location.href =
              formActionURL +
              (formActionURL.indexOf("?") != -1 ? "&" : "?") +
              formURLParameters.join("&");
          }
        });
      }
    });
    var adjustscrollabletabs = function(context) {
      $(
        ".widget-directories-search .tabs,.company-header__company-tabs,.search-results-header .tabs",
        context
      ).each(function() {
        var width = 0,
          $this = $(this);
        $(".tab", $this).each(function() {
          var $that = $(this);
          width += $that.outerWidth(true);
        });
        $('.nav,.company-tabs,.tabs-inner[role="tabs"]', $this).css({
          width: width + 5 + "px"
        });
      });
    };
  }

  // set a timeout to give feedback to user
  $(".download-all").on("click", "a", function() {
    $(this)
      .parent()
      .addClass("loading");
    setTimeout(() => {
      $(this)
        .parent()
        .removeClass("loading");
    }, 5000);
  });

  new AJAXSaveBookmark("[data-ajax-save-article]");
  if (!Abacus.PreventDefault.LongformGalleries) {
    new LongformGalleriesStyleOne(".galleryscroll .trigger");
  }
});

$(window).on("load", function() {
  if (
    document.querySelector('meta[name="showwallpaper"]') &&
    document.querySelector('meta[name="showwallpaper"]').content == "true"
  ) {
    if (!Abacus.PreventDefault.StoryGallery) {
      $(".storyGallery").each(function() {
        new StoryGallery(this);
      });
    }
  }
  $(".abacusPopup.attachments .swiper-wrapper .swiper-slide > .sleeve").each(
    function() {
      if ($(this).find(".zoom").length) {
        if ($(this).find(".zoomable-image").length == 0) {
          new ImageZoom(this);
        }
      }
    }
  );
  $(".storyGallery .swiper-wrapper .swiper-slide > .sleeve ").each(function() {
    if ($(this).find(".zoom").length) {
      if ($(this).find(".zoomable-image").length == 0) {
        new ImageZoom(this);
      }
    }
  });
  if (!Abacus.PreventDefault.Autocomplete) {
    $(".autocomplete").each(function() {
      if (!$(this).hasClass("autocomplete-applied")) {
        new Autocomplete(this);
      }
    });
  }
  // directories search tabs
  if (!Abacus.PreventDefault.Directories) {
    $(".storytext").on("click", ".btn-show-all", function(event) {
      event.preventDefault();
      $(".show-all-fader").toggleClass("expanded");
      $(".btn-show-all-wrapper").hide();
    });
    var scrollabletabs = function() {
      $(".company-header__company-tabs,.search-results-header .tabs").each(
        function() {
          var width = 0,
            $this = $(this);
          $(".tab", $this).each(function() {
            var $that = $(this);
            width += $that.outerWidth(true);
          });
          $('.company-tabs,.tabs-inner[role="tabs"]', $this).css({
            width: width + 5 + "px"
          });
        }
      );
    };
    scrollabletabs();
    // ajax widget call
    if (!document.body.classList.contains("directories")) {
      localStorage.removeItem("abacus:searchfilter:applied");
    }
    var srpurl = localStorage.getItem("abacus:searchfilter:applied");
    if (srpurl) {
      $(".directories .backToSearchresults")
        .css("display", "block")
        .find("a")
        .attr("href", srpurl);
    }
    $(".directories .backToSearchresults").on("click", function() {
      localStorage.removeItem("abacus:searchfilter:applied");
    });
    $(".directory-search .listBlocks").on(
      "click",
      ".image,.link-headline,.company-articles,.link-company",
      function() {
        localStorage.setItem(
          "abacus:searchfilter:applied",
          location.pathname + location.search + location.hash
        );
      }
    );
  }

  setTimeout(() => {
    $("[data-ajax-load-native-content]").each(function() {
      if (this.dataset.contentLoaded == undefined) new NativeContent(this);
    });
  }, 750);

  lazySizes.init();
  $(window).trigger("scroll");
});

$(document).on("lazyloaded", e => {
  $(e.target)
    .parent(
      ".imageWrapper,.videoPreview-thumb,.picture,.display,a.image,.image.layoutIcon,.display,.titleImagePicture .storyPictureWrapper,.company__info-logo,.company-header__logo_inner,.company-footer__logo_inner"
    )
    .addClass("lazyloaded-completed");
});

// when attachments gallery is loaded
$(window).on("abacus:loadGallery:complete", (evt, context) => {
  $(".abacusPopup.attachments .contentWrapper .previous a").focus();
  $(".abacusPopup.attachments .swiper-wrapper .swiper-slide > .sleeve").each(
    function() {
      if ($(this).find(".zoom").length) {
        if ($(this).find(".zoomable-image").length == 0) {
          new ImageZoom(this);
        }
      }
    }
  );
});

// when comments on storypage are sorted
$(window).on("abacus:loadcomments:reloaded", function(evt, context) {
  $("#comments")
    .find("li:not('.editor_comment')")
    .each(function() {
      new CommentVote(this);
    });
  context.classList.add("initialized");
});

$(window).on("abacus:loadcomments:complete:datestimezone", function(
  evt,
  context
) {
  $(context)
    .find(".date")
    .each(function(i, el) {
      new TimeZoneFormat(this);
    });
});

// when dynamic content is loaded each time
$(window).on("abacus:loadcontent:complete", function(evt, context) {
  if (!$("[data-load-more]").hasClass("initialized")) {
    $("[data-load-more]").each(function() {
      new LoadMoreItems(this);
      this.classList.add("initialized");
    });
  }

  if (
    $(context[0]).find(".tabbedblocks").length &&
    !context[0].classList.contains("initialized")
  ) {
    $(context[0])
      .find(".tabbedblocks")
      .each(function() {
        $(this).makeTabbed(".block", ".block > H2, .block > H3");
      });
    context[0].classList.add("initialized");
  }

  // run once for voting
  if (
    context[0].id == "ajaxCommentsList" &&
    !context[0].classList.contains("initialized")
  ) {
    $(context[0])
      .find("li:not('.editor_comment')")
      .each(function() {
        new CommentVote(this);
      });
    $(context[0])
      .find("[ajax-submit-on-change]")
      .each(function() {
        new CommentSort(this);
      });
    $(context[0])
      .find(".date")
      .each(function(i, el) {
        new TimeZoneFormat(this);
      });
    context[0].classList.add("initialized");
  }

  if ($(context).find(".curriculum-explorer").length && !context[0].classList.contains("initialized")) {
    context.find(".curriculum-explorer").each(function() {
      new CurriculumExplorer(this);
    });
    context[0].classList.add("initialized");
  }

  if ($(context).hasClass("category-style-two")) {
    const self = context;
    const lists = $(context).find(".content li");
    if (lists.length >= 10) {
      context.find(".more").addClass("show");
    } else {
      context.addClass("show-all-items");
    }
    context.on("click", ".more", function(evt) {
      evt.preventDefault();
      self.toggleClass("show-lists");
    });
  }

  if (!Abacus.PreventDefault.NewsletterSignup) {
    // Disable double event listeners on each ajax call.
    if (context.hasClass("newsletterSignup")) {
      $(".newsletterSignup").each(function() {
        if (!$(this).hasClass("initiated")) {
          new NewsletterSignup(this);
        }
      });
    }
  }
});

$(window).on("abacus:spinvideopreview:complete", function(evt, context) {
  $(context)
    .find(".date")
    .each(function(i, el) {
      new TimeZoneFormat(this);
    });
});

$(window).on("abacus:customwidget:complete", function(evt, context) {
  if (
    context.data("enableAutocomplete") &&
    !context.hasClass("autocomplete-applied")
  ) {
    let element = context.find(".autocomplete")[0];
    new Autocomplete(element);
  }
});

$(window).on("abacus:loadmore:complete", function(evt, context) {
  $(context)
    .find(".date")
    .each(function(i, el) {
      new TimeZoneFormat(this);
    });
});

$(window).on("abacus:InitUI", function(e, context) {
  // shown on search page
  if (!Abacus.PreventDefault.ShowHideHelp) {
    $(context)
      .find("[data-show-help]")
      .each(function() {
        new ShowHideHelp(this);
      });
  }

  // show on `report a comment` in story page
  $(context)
    .find(".field.reCaptcha")
    .each(function() {
      new ReCaptchaElement(this);
    });
});

$(window).on("abacus:ajaxsearch:complete", function(e, context) {
  // shown on search page
  if (!Abacus.PreventDefault.ShowHideHelp) {
    $(context)
      .find("[data-show-help]")
      .each(function() {
        new ShowHideHelp(this);
      });
  }
});



// WEBPACK FOOTER //
// ./Javascript/core/Abacus.Core.Imports.js